import { MediaQuery as MQ } from '../shared/media-query';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
lazySizes.cfg.loadHidden = 'false';

//custom scrollspy for card & deck pages
if (document.querySelector('tarot-card-bar a[href="#upright"]') && MQ.isMobile()) {
    window.addEventListener('scroll', () => {
        const container = document.querySelector('tarot-card-bar');
        const scrollPos = document.querySelector('article a[href="#upright"]').getBoundingClientRect().bottom;

        if (
            (scrollPos < 145 && !container.classList.contains('show-anchors'))
            ||
            (scrollPos >= 145 && container.classList.contains('show-anchors'))
        ) {
            container.classList.toggle('show-anchors');
        }
    });
}

setInterval(() => {
    const mobileStickyNav = document.querySelector('mobile-sticky-nav');
    const adAdhesion = document.getElementById('pmc-atlasmg-adhesion-bar');

    if (mobileStickyNav && MQ.isMobile()) {
        if (window.scrollY >= 154 && mobileStickyNav.style.bottom != '0px') {
            mobileStickyNav.style.bottom = 0;

            if (adAdhesion) {
                adAdhesion.style.bottom = '79px';
            }
        } else if (window.scrollY < 154 && mobileStickyNav.style.bottom != '-80px') {
            mobileStickyNav.style.bottom = '-80px';

            if (adAdhesion) {
                adAdhesion.style.bottom = 0;
            }
        }
    }
}, 500);

(() => {
    const daily_nav = document.querySelector('daily-nav');
    const daily_button = document.querySelector('.daily-nav-button');

    if (daily_nav && daily_button) {
        daily_button.addEventListener('click', () => {
            daily_nav.classList.toggle('is-open');
        });
    }
})();

//custom scroll postition for daily-links mobile
(() => {
    const container = document.querySelector('.daily-links-container');
    if (container && MQ.isMobile()) {
        container.scrollLeft = 37;
    }
})();
